import { httpStatus } from "@/src/lib/util/config";
import { myAccountApiService } from "@/src/lib/api-services/myAccountApiServices";
import useAuth from "@/src/lib/hooks/useAuth";
import { useSelector } from "react-redux";
import { useCustomQuery } from "@/src/lib/hooks/useFetch";

export function usePatientList() {
    const { isLoggedIn } = useAuth();
    const mobileNumber = useSelector((state) => state.user?.userInfo?.mobileNo);

    const {
        data: patientList,
        isError: isErrorPatientList,
        error: errorPatientList,
        refetch: refetchPatientList,
        isFetching: isFetchingPatientList,
        isLoading: isLoadingPatientList,
    } = useCustomQuery(
        ["patient_list", mobileNumber],
        myAccountApiService.getPatientList,
        {
            enabled: true,
        }
    );

    if (isErrorPatientList) {
        const { status, data } = errorPatientList?.response || {};
        if (status === httpStatus.CONFLICT) {
        } else if (status === httpStatus.BAD_REQUEST) {
        } else {
            throw errorPatientList;
        }
    }

    return {
        patientList: patientList?.data || [],
        isErrorPatientList,
        errorPatientList,
        refetchPatientList,
        isFetchingPatientList,
        isLoadingPatientList,
    };
}

export function usePatientAddressList(flag = false) {
    const { isLoggedIn } = useAuth();

    const mobileNumber = useSelector((state) => state.user?.userInfo?.mobileNo);

    const {
        data: patientAddressListData,
        isError: isErrorPatientAddressList,
        error: errorPatientAddressList,
        refetch: refetchPatientAddressList,
        isFetching: isFetchingPatientAddressList,
        isLoading: isLoadingPatientAddressList,
    } = useCustomQuery(
        ["patient_address_list", mobileNumber],
        myAccountApiService.getPatientAddressList,
        {
            enabled: isLoggedIn && flag,
        }
    );

    let patientAddressList = patientAddressListData?.data || [];

    if (isErrorPatientAddressList) {
        const { status } = errorPatientAddressList?.response || {};
        if (
            status === httpStatus?.NOT_FOUND ||
            status === httpStatus?.BAD_REQUEST
        ) {
            patientAddressList = [];
        } else {
            throw errorPatientAddressList;
        }
    }

    return {
        patientAddressList,
        isErrorPatientAddressList,
        errorPatientAddressList,
        refetchPatientAddressList,
        isFetchingPatientAddressList,
        isLoadingPatientAddressList,
    };
}

export function useGetPatientAddressDetails(addressId) {
    const {
        data: patientAddressDetails,
        isError: isErrorPatientAddressDetails,
        error: errorPatientAddressDetails,
        refetch: refetchPatientAddressDetails,
        isFetching: isFetchingPatientAddressDetails,
        isLoading: isLoadingPatientAddressDetails,
    } = useCustomQuery(
        ["patient_address_details", addressId],
        () => myAccountApiService.getAddressDetailsById(addressId),
        {
            enabled: !!addressId,
        }
    );

    if (isErrorPatientAddressDetails) {
        const { status, data } = errorPatientAddressDetails?.response || {};
        if (status === httpStatus.CONFLICT) {
        } else if (status === httpStatus.BAD_REQUEST) {
        } else {
            throw errorPatientAddressDetails;
        }
    }

    return {
        patientAddressDetails: patientAddressDetails?.data || [],
        isErrorPatientAddressDetails,
        errorPatientAddressDetails,
        refetchPatientAddressDetails,
        isFetchingPatientAddressDetails,
        isLoadingPatientAddressDetails,
    };
}
